// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".memberPopText{top:20%;background-color:#fff;margin:10px;border-radius:10px;padding:15px;min-height:300px;max-height:60%;position:absolute;z-index:999}.memberPopAlimImg{width:100px;right:20px;float:right;position:absolute;z-index:999}", ""]);
// Exports
module.exports = exports;
